import React from "react";
import styled from "styled-components";
import { device } from "../../utils/helperFunctions";

function Input(props) {
  return (
    <CustomInput
      {...props}
      style={props.style}
      type="text"
      value={props.value}
      onChange={props.onChange}
      maxLength={props.maxLength}
      manLength={props.minLength}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      autoComplete={props.autoComplete || "off"}
      autoFocus={props.autoFocus}
      disabled={props.disabled}
      width={props.width}
      height={props.height}
    />
  );
}

export const CustomInput = styled.input`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  border: ${(props) => props.border || "none"};
  &:focus {
    outline: none;
    border: 2px solid #273135;
  }
  ::placeholder,
  ::-webkit-input-placeholder {
    font-family: Manrope;
    font-weight: 500;
    font-size: 40px;
    line-height: 55px;
    color: #222222;
    opacity: 0.3;

    @media ${device.tablet} {
      font-size: 20px;
      line-height: 20px;
    }
  }
  :-ms-input-placeholder {
    font-family: Manrope;
    font-weight: 500;
    font-size: 40px;
    line-height: 55px;
    color: #222222;
    opacity: 0.3;

    @media ${device.tablet} {
      font-size: 20px;
      line-height: 20px;
    }
  }
`;

export default Input;
